import { Component }              from '@angular/core';
import { MatDialogRef }            from '@angular/material';

@Component({
  selector: 'sa-saving-dialog',
  template: `
    <div class="saving-cloak">
      <div class="progress">
        <div style="width:100; text-align: center">
          <mat-spinner></mat-spinner>
        </div>
        <div style="width:100; text-align: center">Ukládám změny</div>
      </div>
    </div>
  `
})
export class SavingDialogComponent {

  constructor(public dialogRef: MatDialogRef<SavingDialogComponent>) {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/saving-dialog.component.ts